var data = {
  "width": 32,
  "height": 32,
  "body": "<circle cx=\"16\" cy=\"16\" r=\"8\" fill=\"currentColor\"/>"
};
exports.__esModule = true;
exports.default = data;